<template>
  <div class="tfa-wrapper wrapper-1 bg-white" v-if="isMounted">
    <!--TITLE-->
    <v-card-title class="text-center bg-grey fs-1-5r card-title">
      {{ $t('Email Verification') }}
    </v-card-title>

    <div class="pa-2">
      <div v-if="firstDigits && lastDigits">
        <span
          >{{ $t('A verification code was sent to your email') }}:
          {{ firstDigits }}****{{ lastDigits }}</span
        >
      </div>
      <div v-else-if="lastDigits">
        <span
          >{{ $t('A verification code was sent to phone that ends with') }}:
          ****{{ lastDigits }}</span
        >
      </div>

      <v-text-field
        v-model="code"
        :label="$t('Verification Code')"
        @keypress.enter="confirmLogin"
        autofocus
        outlined
        class="pa-0 ma-0 mt-4"
        placeholder=" "
        type="number"
        hide-details
        dense
        maxLength="6"
      ></v-text-field>
      <div class="d-flex justify-center">
        <Button
          :disabled="code == 0"
          :clickAction="confirmLogin"
          :text="$t('Confirm')"
          :loading="loading"
          class="my-2"
          width="120px"
        ></Button>
      </div>
      <v-divider class="my-2"></v-divider>
      <div class="d-flex justify-end align-center">
        <small class="light-text f-12" v-if="timerTime > 0">
          {{ $t('You can ask for a new code in') }}: {{ timerTime }}
          {{ $t('seconds') }}
        </small>

        <Button
          v-else
          :clickAction="sendCodeClicked"
          :text="$t('Send New Code')"
          :disabled="timerTime > 0"
          width="120px"
          btnType="grey"
        >
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { api } from '@/config'
import { mapMutations } from 'vuex'

export default {
  name: 'TfaCode',
  data() {
    return {
      timerTime: 0,
      timer: null,
      loading: false,
      code: '',
      lastDigits: null,
      firstDigits: null,
      recipient: null,
      isMounted: false,
    }
  },
  props: {
    setIsAuthenticated: Function,
    recipientEmail: String,
    casualEmail: String,
    token: String,
    operationId: String,
  },
  emits: ['set-token'],
  components: { Button },
  methods: {
    ...mapMutations(['SET_PROCESSING']),
    async sendCodeClicked() {
      this.restartTimer()
      await this.sendCode()
    },
    async sendCode() {
      try {
        console.log("this.casualEmail: " + this.casualEmail)
        this.SET_PROCESSING(true)
        const res = await api.post(
          `casuals/send-tfa-code${this.operationId ? '/' + this.operationId : ''}?bearer=${this.token}`,
          {
            cipherText: this.encryptedPhoneOrEmail,
            registeredEmail: this.recipientEmail,
            casualEmail: this.casualEmail,
          }
        )
        // if (res.data.token){
        //   this.$emit('set-token', res.data.token)
        //   this.setIsAuthenticated()
        // }
        if (res.data.lastDigits) {
          this.lastDigits = res.data.lastDigits
        }
        else {
          this.lastDigits = null
          await this.confirmLogin()
        }
        if (res.data.firstDigits) {
          this.firstDigits = res.data.firstDigits
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.SET_PROCESSING(false)
      }
    },
    async confirmLogin() {
      try {
        this.SET_PROCESSING(true)
        const res = await api.post(`casuals/verify-code/${this.code ? this.code : '0'}${this.operationId ? '/' + this.operationId : ''}?bearer=${this.token}`, {
            cipherText: this.encryptedPhoneOrEmail,
            registeredEmail: this.recipientEmail,
            casualEmail: this.casualEmail,
          })
          console.log('res:', res)
        if (res.status !== 200) throw Error
        if (res.data.token) {
          this.$emit('set-token', res.data.token)
        }
        this.setIsAuthenticated()
      } catch (e) {
        console.log(e)
      } finally {
        this.SET_PROCESSING(false)
      }
    },

    restartTimer() {
      clearInterval(this.timer)
      this.timerTime = 30
      this.timer = setInterval(() => {
        --this.timerTime
      }, 1000)
    },
  },
  async beforeMount() {
    console.log('TFA beforeMount')
    await this.sendCode()
    this.restartTimer()
    this.lastEmailLetters = this.casualEmail ? this.casualEmail.slice(-5) : ""
    this.firstEmailLetters = this.casualEmail ? this.casualEmail.slice(0, 3) : ""
    this.isMounted = true
    console.log('operationId: ' + this.operationId)
  },
}
</script>

<style lang="scss" scoped>
.tfa-wrapper {
  width: 250px;
}
h1 {
  font-size: 1.25rem;
}

.card-title {
  border-radius: 10px 10px 0 0;
}
</style>
